import { render, staticRenderFns } from "./ConsultaItemBemPermanenteView.vue?vue&type=template&id=294e6e74"
import script from "./ConsultaItemBemPermanenteView.vue?vue&type=script&lang=js"
export * from "./ConsultaItemBemPermanenteView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports